import React from 'react';
import styled from 'styled-components';

import logo from '../assets/img/logo.png';
import fotoGrupo from '../assets/img/foto_grupo.jpeg';

const HeroSectionContainer = styled.section`
  display: flex;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const HeroLeft = styled.div`
  flex: 1.15;
  background: #ba3b3b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #f0eadd;
  padding: 0 0 0 4vw;
  position: relative;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 50vh;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  width: 100%;

  @media (max-width: 900px) {
    height: auto;
    padding: 32px 0;
  }
`;

const HeroLogo = styled.img`
  width: 370px;
  max-width: 90%;
  margin-bottom: 38px;

  @media (max-width: 1100px) {
    width: 250px;
  }

  @media (max-width: 900px) {
    width: 60vw;
    margin-bottom: 24px;
  }
`;

const HeroSubtitle = styled.div`
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 28.1px;
  letter-spacing: 0.35em;
  text-align: center;
  margin-bottom: 0;
  color: #f0eadd;
  margin-top: 0;

  @media (max-width: 1100px) {
    font-size: 18px;
  }
`;

const HeroRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #222;
  overflow: hidden;

  @media (max-width: 900px) {
    flex: unset;
    width: 100vw;
    min-height: 50vh;
  }
`;

const HeroImg = styled.img`
  width: 100%;
  height: 100vh;
  object-fit: cover;
  filter: grayscale(1);

  @media (max-width: 900px) {
    height: 50vh;
  }
`;

const HeroSection = () => {
  return (
    <HeroSectionContainer>
      <HeroLeft>
        <HeroContent>
          <HeroLogo src={logo} alt="Logo Quatro Takes" />
          <HeroSubtitle>PORTAL DE ENTRETENIMENTO</HeroSubtitle>
        </HeroContent>
      </HeroLeft>
      <HeroRight>
        <HeroImg src={fotoGrupo} alt="Equipe Quatro Takes" />
      </HeroRight>
    </HeroSectionContainer>
  );
};

export default HeroSection;
